import { render, staticRenderFns } from "./DebtorNoticeControl.vue?vue&type=template&id=0281cc82&"
import script from "./DebtorNoticeControl.vue?vue&type=script&lang=js&"
export * from "./DebtorNoticeControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports